var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 38H29V34H20V38H15C14.448 38 14 38.448 14 39V41C14 41.552 14.448 42 15 42H33C33.552 42 34 41.552 34 41V39C34 38.448 33.552 38 33 38Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35H7C5.895 35 5 34.105 5 33V9C5 7.895 5.895 7 7 7H41C42.105 7 43 7.895 43 9V33C43 34.105 42.105 35 41 35Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9H7V33H41V9Z",
    fill: "url(#paint2_radial)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M14 12.5V19C14 19.72 13.61 20.38 13 20.73V35H9V20.73C8.39 20.38 8 19.72 8 19V12.5C8 11.67 8.67 11 9.5 11H12.5C13.33 11 14 11.67 14 12.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M13.5 12.5V19C13.5 19.65 13.08 20.21 12.5 20.41V35H9.5V20.41C8.92 20.21 8.5 19.65 8.5 19V12.5C8.5 11.95 8.95 11.5 9.5 11.5H12.5C13.05 11.5 13.5 11.95 13.5 12.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19H10V41C10 41.552 10.448 42 11 42C11.552 42 12 41.552 12 41V19Z",
    fill: "#0D62AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12H9.5C9.224 12 9 12.224 9 12.5V15L11 16L13 15V12.5C13 12.224 12.776 12 12.5 12Z",
    fill: "#E9EBED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H10C9.448 20 9 19.552 9 19V15H13V19C13 19.552 12.552 20 12 20Z",
    fill: "#0078D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 18H10.5C10.224 18 10 17.776 10 17.5V15H12V17.5C12 17.776 11.776 18 11.5 18Z",
    fill: "#0D62AB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M43 28.2V33C43 34.1 42.1 35 41 35H29V38H33C33.55 38 34 38.45 34 39V41C34 41.55 33.55 42 33 42H27.75C27.27 40.76 27 39.41 27 38C27 31.93 31.93 27 38 27C39.8 27 41.5 27.43 43 28.2Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M43 28.77V33C43 34.1 42.1 35 41 35H29V38H33C33.55 38 34 38.45 34 39V41C34 41.55 33.55 42 33 42H28.3C27.78 40.77 27.5 39.42 27.5 38C27.5 32.21 32.21 27.5 38 27.5C39.81 27.5 41.52 27.96 43 28.77Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48C43.5228 48 48 43.5228 48 38C48 32.4772 43.5228 28 38 28C32.4772 28 28 32.4772 28 38C28 43.5228 32.4772 48 38 48Z",
    fill: "url(#paint3_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.536 33.757L42.243 34.464C42.438 34.659 42.438 34.976 42.243 35.171L35.172 42.242C34.977 42.437 34.66 42.437 34.465 42.242L33.758 41.535C33.563 41.34 33.563 41.023 33.758 40.828L40.829 33.757C41.024 33.562 41.34 33.562 41.536 33.757Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.243 41.536L41.536 42.243C41.341 42.438 41.024 42.438 40.829 42.243L33.758 35.172C33.563 34.977 33.563 34.66 33.758 34.465L34.465 33.758C34.66 33.563 34.977 33.563 35.172 33.758L42.243 40.829C42.438 41.024 42.438 41.34 42.243 41.536Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24,
    y1: 33.983,
    x2: 24,
    y2: 42.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#484B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#656D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#727D86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.663,
    y1: 8.059,
    x2: 38.122,
    y2: 32.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F979E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.166 7.59) scale(33.548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 28,
    y1: 38,
    x2: 48,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.493a2d9fc5896774e391ab2d7ceeeb70.svg";
export { ForwardRef as ReactComponent };